<template>
    <div id="app-layout-left-column" :class="{'--is-guest': isGuest}">
		<div id="app-layout-left-column__content" :class="{'--blocks-menu-active': !isLeftColumn('appliedBlocks')}">
            <AppliedBlocks v-show="isLeftColumn('appliedBlocks')" />
            <LUTPreviews v-show="showLutPreviews" />
            <BlocksMenu v-show="!isLeftColumn('appliedBlocks')" />
        </div>


        <div id="app-layout-left-column__navigation" class="d-flex flex-column px-2 py-3">
            <ShowAppliedBlocksButtons :class="{'v-btn--active': isLeftColumn('appliedBlocks') && image && !IDT.initial}" />
            <ShowLutPreviewsButton :class="{'v-btn--active': showLutPreviews && image && !IDT.initial && previewBasedBlock}" />
            <div class="group-separator"></div>
            <AddMagicModeButton />
            <div class="group-separator"></div>
			<div class="d-flex flex-column"
				 ref="addControlButtonsContainer"
				 @mouseenter="onMouseEnter"
				 @mouseleave="onMouseLeave"
				 name="add-control-buttons-container"
				 style="gap: 8px;"
			>
				<ShowControlBlockListButton :class="{'v-btn--active': isLeftColumn('controlBlocks')}" />
				<ShowLegacyBlockListButton :class="{'v-btn--active': isLeftColumn('legacyBlocks')}" />
				<ShowCreativeBlockListButton :class="{'v-btn--active': isLeftColumn('creativeBlocks')}" />
				<ShowMagicModeBlockListButton :class="{'v-btn--active': isLeftColumn('magicModeBlocks')}" />
				<ShowProductListButton :class="{'v-btn--active': isLeftColumn('products')}" />
			</div>
			<div class="group-separator"></div>
            <ShowLayoutListButton :class="{'v-btn--active': isLeftColumn('layouts')}" />

			<tippy
				trigger="manual"
				hideOnClick="toggle"
				to="add-control-buttons-container"
				placement="right"
				zIndex="50"
			>
                <span style="text-align: left; line-height: 1.2; display: block">
                    Add a Tool to <br />
                    start editing
                </span>
			</tippy>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import LUTPreviews from "@/components/app/blocks/LUTPreviews.vue";
import AddMagicModeButton from "@/components/app/buttons/AddMagicModeButton.vue";
import ShowLutPreviewsButton from "@/components/app/buttons/ShowLutPreviewsButton.vue";
import ShowCreativeBlockListButton from "@/components/app/buttons/ShowCreativeBlockListButton.vue";
import ShowControlBlockListButton from "@/components/app/buttons/ShowControlBlockListButton.vue";
import ShowLegacyBlockListButton from "@/components/app/buttons/ShowLegacyBlockListButton.vue";
import ShowMagicModeBlockListButton from "@/components/app/buttons/ShowMagicModeBlockListButton.vue";
import ShowProductListButton from "@/components/app/buttons/ShowProductListButton.vue";
import ShowLayoutListButton from "@/components/app/buttons/ShowLayoutListButton.vue";
import AppliedBlocks from "@/components/app/blocks/AppliedBlocks.vue";
import BlocksMenu from "@/components/app/blocks/BlocksMenu.vue";
import ShowAppliedBlocksButtons from "@/components/app/buttons/ShowAppliedBlocksButtons.vue";

export default {
    name: "MainLayoutLeft",

    components: {
        ShowAppliedBlocksButtons,
        BlocksMenu,
        AppliedBlocks,
        ShowLayoutListButton,
        ShowProductListButton,
        ShowMagicModeBlockListButton,
        ShowControlBlockListButton,
        ShowLegacyBlockListButton,
        ShowCreativeBlockListButton,
        ShowLutPreviewsButton,
        AddMagicModeButton,
        LUTPreviews,
    },

	mounted() {
		this.$root.$refs.addControlButtonsContainer = this.$refs.addControlButtonsContainer;
	},

    computed: {
        ...mapState("UI", ['showLutPreviews', 'previewBasedBlock']),
        ...mapState("App", ['IDT']),
        ...mapState("Projects", ['image']),
        ...mapGetters("User", ["isGuest"]),
        ...mapGetters('UI', ['isLeftColumn']),
    },

	methods: {
		onMouseEnter() {
			this.$root.$refs.addControlButtonsContainer.mouseOver = true;
		},

		onMouseLeave() {
			this.$root.$refs.addControlButtonsContainer.mouseOver = false;

			setTimeout(() => {
				this.$nextTick(() => {
					if ($(this.$root.$refs.addControlButtonsContainer).find('[aria-describedBy]').length > 0) return;

					UI.toggleStartTips()
				})
			}, 500)
		}
	}
}
</script>

<style lang="scss" scoped>
#app-layout-left-column {
    background-color: var(--bg-sidebar-left);
    display: grid;
    grid-template-columns: minmax(0, 100%) auto;
    grid-template-rows: minmax(0, 100%);
    grid-template-areas: "blocks" "add-block";
    border-radius: 0 var(--box-rounding) var(--box-rounding) 0;
    height: 100%;
    position: relative;

    &:has(#lut-previews-container:not(.hide)) {
        border-radius: initial;
    }

    &.--is-guest {
        padding-bottom: 20px;
        grid-template-rows: 1fr;
        grid-template-areas: "tools";
    }

    &__navigation {
        gap: 8px;
        border-left: 1px solid var(--color-group-separator);

        ::v-deep .v-btn {
            min-width: auto;
            height: auto;
            box-shadow: none;
            background-color: transparent;
            color: var(--font-default-color);
            padding: 3px;

            &--active {
                &::before {
                    background-color: var(--color-accent);
                    opacity: 0.4;
                }
            }

            &--disabled,
            &--disabled .v-icon {
                background-color: transparent !important;
                color: var(--font-default-color) !important;
                opacity: 0.4;
            }

            i {
                font-size: 1.7rem;
            }
        }

        .group-separator {
            width: 100%;
            border-bottom: 1px solid var(--color-group-separator);
            margin: 10px 0;
        }
    }

    &__content {
        display: grid;
        grid-template-rows: minmax(0, 100%);
        padding: 12px 8px;

		&.--blocks-menu-active {
			padding-bottom: 0;
		}

        ::v-deep &__title {
            font-size: 1.2rem;
            font-weight: bold;
            line-height: 1.4;
            text-align: left;
            padding: 10px 0;
            color: var(--color-title-light)
        }

        ::v-deep &__message {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 50%;
            //transform: translateY(-50%);

            > span {
                line-height: 1.5;
                text-align: center;
                text-transform: uppercase;
            }
        }
    }


}
</style>